<template>
  <div class="animated fadeIn">
    <b-row>
      <RegionalAnalyticsActiveBacklog
        :lgSize="6"
        :lgOffset="0"
        :locParam="1"
        :idCity="0"
      ></RegionalAnalyticsActiveBacklog>
      <RegionalAnalyticsDeliveredEquipment
        :lgSize="6"
        :lgOffset="0"
        :locParam="1"
        :idCity="0"
      ></RegionalAnalyticsDeliveredEquipment>
    </b-row>
  </div>
</template>

<script>
import RegionalAnalyticsActiveBacklog from "../../../components/regional-analytics/RegionalAnalyticsActiveBacklog.vue";
import RegionalAnalyticsDeliveredEquipment from "../../../components/regional-analytics/RegionalAnalyticsDeliveredEquipment";

import { Chart } from "highcharts-vue";

export default {
  name: "RegionalAnalytics",
  components: {
    RegionalAnalyticsActiveBacklog,
    RegionalAnalyticsDeliveredEquipment,
    highcharts: Chart
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
